module.exports = __webpack_public_path__ + "static/media/la_deviation.86904c8d.png";